<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="show"
      max-width="600"
      @input="v => v || closeDialog()"
    >
      <v-card>
        <v-card-title :class="colorTheme">
          <span class="headline white--text text-uppercase">Update File</span>
        </v-card-title>
        <v-alert
          v-if="error"
          type="error"
          :value="true"
          class="mt-2"
        >
          {{ error }}
        </v-alert>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container fluid>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="title"
                    label="Template Name"
                    :color="colorTheme"
                    :rules="requiredRule"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                >
                  <v-checkbox
                    v-model="template"
                    label="Template"
                    :color="colorTheme"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            :color="colorTheme"
            flat="flat"
            :disabled="processing"
            @click="closeDialog()"
          >
            cancel
          </v-btn>

          <v-btn
            :color="colorTheme"
            flat="flat"
            :disabled="processing"
            @click="submit()"
          >
            edit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'UpdateFile',
  props: {
    file: {
      type: Object,
      default: () => ({}),
    },
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    processing: {
      type: Boolean,
      default: false,
    },
    submitAction: {
      type: Function,
      required: true,
      default: () => ({}),
    },
    cancelAction: {
      type: Function,
      required: true,
      default: () => ({}),
    },
    colorTheme: {
      type: String,
      default: 'blue',
    },
  },
  data() {
    return {
      valid: true,
      show: this.dialog,
      category: null,
      fileName: null,
      title: null,
      data: null,
      template: null,
      error: '',
      requiredRule: [
        v => !!v || 'field is required',
      ],
    };
  },
  watch: {
    dialog(val) {
      this.show = val;
      if (this.file) {
        this.category = this.file.category;
        this.fileName = this.file.fileName;
        this.title = this.file.title;
        this.data = this.file.data;
        this.created_at = this.file.created_at;
        this.deleted_at = this.file.deleted_at;
        this.template = this.file.template;
      }
    },
  },
  methods: {
    ...mapActions(['uploadFile']),
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          const uploadParams = {
            category: this.category,
            fileName: this.fileName,
            title: this.title,
            data: this.data,
            created_at: this.created_at,
            deleted_at: this.deleted_at,
            dbEdit: true,
          };
          if (this.template) {
            uploadParams.template = true;
          }
          await this.submitAction(uploadParams);
          this.closeDialog();
        } catch (err) {
          // eslint-disable-next-line no-console
          this.error = err.response.data.error;
        }
      }
    },
    closeDialog() {
      this.cancelAction();
      this.setToDefault();
    },
    setToDefault() {
      this.category = null;
      this.fileName = null;
      this.title = null;
      this.data = null;
      this.created_at = null;
      this.deleted_at = null;
      this.template = null;
      this.valid = true;
      this.error = '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financialProducts/UpdateFile.vue